const ANCHORS = new Set(['marchi', 'boutique', 'contatti']);

function getHeaderOffset() {
  const headerHeight = parseFloat(
    getComputedStyle(document.body).getPropertyValue('--header-group-height'),
  );
  return (Number.isFinite(headerHeight) && headerHeight > 0 ? headerHeight : 80) + 16;
}

function isHomePath(pathname) {
  return pathname === '/' || pathname === '';
}

/**
 * @param {string} anchorId
 * @param {{ behavior?: ScrollBehavior }} [options]
 * @returns {boolean}
 */
function scrollToAnchor(anchorId, { behavior = 'smooth' } = {}) {
  if (!anchorId || !ANCHORS.has(anchorId)) return false;

  const target = document.getElementById(anchorId);
  if (!target) return false;

  const top = target.getBoundingClientRect().top + window.scrollY - getHeaderOffset();
  window.scrollTo({ top: Math.max(0, top), behavior });
  return true;
}

function scrollFromHash() {
  const anchorId = window.location.hash.slice(1);
  if (!anchorId) return;

  let attempts = 0;
  const tryScroll = () => {
    const behavior = attempts === 0 ? 'smooth' : 'auto';
    if (scrollToAnchor(anchorId, { behavior })) return;
    if (++attempts < 30) requestAnimationFrame(tryScroll);
  };

  tryScroll();
}

function closeMobileMenu() {
  document.querySelector('header-drawer details[open]')?.removeAttribute('open');
  document.querySelector('.menu-drawer details[open]')?.removeAttribute('open');
}

document.addEventListener('click', (event) => {
  const link = event.target instanceof Element ? event.target.closest('a[href*="#"]') : null;
  if (!link) return;

  const url = new URL(link.href, window.location.href);
  const anchorId = url.hash.slice(1);
  if (!ANCHORS.has(anchorId)) return;

  const navigatingHome = isHomePath(url.pathname);
  const onHomepage = isHomePath(window.location.pathname);

  if (onHomepage && navigatingHome) {
    event.preventDefault();
    const newUrl = new URL(window.location.href);
    newUrl.hash = anchorId;
    history.pushState(null, '', newUrl);
    scrollToAnchor(anchorId);
    closeMobileMenu();
  }
});

document.addEventListener('DOMContentLoaded', scrollFromHash, { once: true });
window.addEventListener('hashchange', scrollFromHash);
window.addEventListener('pagereveal', () => setTimeout(scrollFromHash, 50));
